import encoding from "k6/encoding";
import secrets from "k6/secrets";
import { buildLogLine, pushToLoki } from "../internal/push.ts";
import { chunkBase64 } from "../internal/chunking.ts";
import type { Store } from "../types.ts";

export interface LokiConfig {
  chunkSize?: number;
}

/**
 * Creates a Loki storage strategy that encodes the screenshot as base64,
 * splits it into chunks, and pushes them directly to Loki.
 */
export function loki(config: LokiConfig = {}): Store {
  return {
    async upload(
      buffer: ArrayBuffer,
      uuid: string,
      caption: string,
    ): Promise<void> {
      const lokiHost = await secrets.get("sm-screenshot-loki-host");
      const lokiAuth = await secrets.get("sm-screenshot-loki-auth");
      const creds = { host: lokiHost, auth: lokiAuth };

      const base64 = encoding.b64encode(buffer);
      const chunks = chunkBase64(base64, config.chunkSize);
      const screenshotSize = `${Math.ceil(base64.length * 0.75)} bytes`;
      const baseNano = BigInt(Date.now()) * 1_000_000n;

      for (let i = 0; i < chunks.length; i++) {
        const tsNano = String(baseNano + BigInt(i));

        pushToLoki(
          [
            {
              stream: {
                source: "synthetic-monitoring-agent-screenshot",
                level: "info",
              },
              values: [
                [
                  tsNano,
                  buildLogLine("info", "page screenshot", {
                    id: uuid,
                    screenshot_base64: chunks[i],
                    caption,
                    screenshot_size_bytes: screenshotSize,
                    chunk_index: i,
                    chunk_total: chunks.length,
                  }),
                ],
              ],
            },
          ],
          i === 0 ? uuid : null,
          creds,
        );
      }
    },
  };
}
